// extracted by mini-css-extract-plugin
export var element = "Image-module--element--9f961";
export var fill = "Image-module--fill--f948b";
export var image = "Image-module--image--23091";
export var placeholder = "Image-module--placeholder--fc0e7";